<div class="search-trainer">
    <div class="filters-parent">
        <div class="filters">
            <div style="float:right;"
                 class="label label-default label-skill label-skill--refuse-highlight">
                {{'session-details.refuse' | translate}}
            </div>
            <div style="float:right;"
                 class="label label-default label-skill label-skill--followed-highlight">
                {{'session-details.followed' | translate}}
            </div>
            <div style="float:right;"
                 class="label label-default label-skill label-skill--wished-highlight">
                {{'session-details.wished' | translate}}
            </div>
            <div style="float:right;"
                 class="label label-default label-skill label-skill--given-highlight">
                {{'session-details.given' | translate}}
            </div>
            <div style="float:right;"
                 class="label label-default label-skill label-skill--can-highlight">
                {{'session-details.can' | translate}}
            </div>
            <label class="control-label" for="search">{{'session-details.search' | translate}}</label>
            <input class="form-control input-filter"
                   id="search"
                   type="text"
                   [(ngModel)]="search"
                   (ngModelChange)="searchByNameOrSkill()"
                   placeholder="{{ 'session-details.filter' | translate}}">
            <select class="form-control" class="agency-filter"
                    [(ngModel)]="selectedAgency">
                <option>Toutes les agences</option>
                <option *ngFor="let agency of agencies" [ngValue]="agency.name">
                    {{agency.name | cleanAgencyName}}
                </option>
            </select>
            <select class="form-control" class="language-filter"
                    [(ngModel)]="selectedLanguage">
                <option value="all">{{'global.language.all' | translate}}</option>
                <option
                    *ngFor="let language of availableLanguages"
                    [ngValue]="language.code">
                    {{'global.language.' + language.code | translate}}
                </option>
            </select>
            <div (click)="toggleShowOnlyActiveTrainers()" class="active-filter">Active:
                <span *ngIf="showOnlyActiveTrainers"><i class="fa fa-check-circle" aria-hidden="true"></i></span>
                <span *ngIf="!showOnlyActiveTrainers"><i class="fa fa-circle-thin" aria-hidden="true"></i></span>
            </div>
        </div>
    </div>

    <form #selecttrainers="ngForm" (ngSubmit)="sendMail()" class="form-search-results"
          class="form-search-results" novalidate>
        <div class="search-results" *ngIf="selectedTrainers">
            <div class="trainer-list" *ngIf="search !== ''">
                <div class="filterMetadata">
                    <div class="flex">
                        <div class="counter">
                            {{filterMetadata.countName}} {{ filterMetadata.countName > 0 ? 'formateurs' : 'formateur' }} {{ filterMetadata.countName > 0 ? 'trouvés' : 'trouvé' }} dont le nom contient "{{search}}"
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="trainer-details"
                    *ngFor="let trainer of trainers | filterByNameOrLabel:search:showOnlyActiveTrainers:filterMetadata:'name' | filterByAgency:selectedAgency:showOnlyActiveTrainers:filterMetadata:'name' | filterByLanguage:selectedLanguage:filterMetadata:'name'">
                    <span class="input-group-addon white-icon">
                        <input (ngModelChange)="toggleTrainerSelectedToSendMail(trainer.id)"
                                [(ngModel)]="selectedTrainers[trainer.id].selected"
                                [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                                aria-label="checkbox-trainer">
                    </span>
                    <div class="trainer-line"><trainer-card [trainer]="trainer" [inline]="true"></trainer-card></div>
                </div>
            </div>




            <div class="trainer-list" *ngIf="search !== ''">
                <div class="filterMetadata">
                    <div class="flex">
                        <div class="counter">
                            {{filterMetadata.countCan}} {{ filterMetadata.countCan > 0 ? 'formateurs' : 'formateur' }} sont "Validé/Certifié" sur la formation "{{search}}"
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="trainer-details"
                    *ngFor="let trainer of trainers | filterByNameOrLabel:search:showOnlyActiveTrainers:filterMetadata:'can' | filterByAgency:selectedAgency:showOnlyActiveTrainers:filterMetadata:'can' | filterByLanguage:selectedLanguage:filterMetadata:'can'">
                    <span class="input-group-addon white-icon">
                        <input (ngModelChange)="toggleTrainerSelectedToSendMail(trainer.id)"
                                [(ngModel)]="selectedTrainers[trainer.id].selected"
                                [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                                aria-label="checkbox-trainer">
                    </span>
                    <div class="trainer-line"><trainer-card [trainer]="trainer" [inline]="true"></trainer-card></div>
                </div>
            </div>

            <div class="trainer-list" *ngIf="search !== ''">
                <div class="filterMetadata">
                    <div class="flex">
                        <div class="counter">
                            {{filterMetadata.countGiven}} {{ filterMetadata.countGiven > 0 ? 'formateurs' : 'formateur' }} ont "Donnée" la formation "{{search}}"
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="trainer-details"
                    *ngFor="let trainer of trainers | filterByNameOrLabel:search:showOnlyActiveTrainers:filterMetadata:'given' | filterByAgency:selectedAgency:showOnlyActiveTrainers:filterMetadata:'given' | filterByLanguage:selectedLanguage:filterMetadata:'given'">
                    <span class="input-group-addon white-icon">
                        <input (ngModelChange)="toggleTrainerSelectedToSendMail(trainer.id)"
                                [(ngModel)]="selectedTrainers[trainer.id].selected"
                                [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                                aria-label="checkbox-trainer">
                    </span>
                    <div class="trainer-line"><trainer-card [trainer]="trainer" [inline]="true"></trainer-card></div>
                </div>
            </div>

            <div class="trainer-list" *ngIf="search !== ''">
                <div class="filterMetadata">
                    <div class="flex">
                        <div class="counter">
                            {{filterMetadata.countWished}} {{ filterMetadata.countWished > 0 ? 'formateurs' : 'formateur' }} "Souhaite animer" la formation "{{search}}"
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="trainer-details"
                    *ngFor="let trainer of trainers | filterByNameOrLabel:search:showOnlyActiveTrainers:filterMetadata:'wished' | filterByAgency:selectedAgency:showOnlyActiveTrainers:filterMetadata:'wished' | filterByLanguage:selectedLanguage:filterMetadata:'wished'">
                    <span class="input-group-addon white-icon">
                        <input (ngModelChange)="toggleTrainerSelectedToSendMail(trainer.id)"
                                [(ngModel)]="selectedTrainers[trainer.id].selected"
                                [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                                aria-label="checkbox-trainer">
                    </span>
                    <div class="trainer-line"><trainer-card [trainer]="trainer" [inline]="true"></trainer-card></div>
                </div>
            </div>

            <div class="trainer-list" *ngIf="search !== ''">
                <div class="filterMetadata">
                    <div class="flex">
                        <div class="counter">
                            {{filterMetadata.countFollowed}} {{ filterMetadata.countFollowed > 0 ? 'formateurs' : 'formateur' }} ont "Suivie" la formation "{{search}}"
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="trainer-details"
                    *ngFor="let trainer of trainers | filterByNameOrLabel:search:showOnlyActiveTrainers:filterMetadata:'followed' | filterByAgency:selectedAgency:showOnlyActiveTrainers:filterMetadata:'followed' | filterByLanguage:selectedLanguage:filterMetadata:'followed'">
                    <span class="input-group-addon white-icon">
                        <input (ngModelChange)="toggleTrainerSelectedToSendMail(trainer.id)"
                                [(ngModel)]="selectedTrainers[trainer.id].selected"
                                [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                                aria-label="checkbox-trainer">
                    </span>
                    <div class="trainer-line"><trainer-card [trainer]="trainer" [inline]="true"></trainer-card></div>
                </div>
            </div>

            <div class="trainer-list" *ngIf="search !== ''">
                <div class="filterMetadata">
                    <div class="flex">
                        <div class="counter">
                            {{filterMetadata.countRefuse}} {{ filterMetadata.countRefuse > 0 ? 'formateurs' : 'formateur' }} "Ne souhaite pas animer" la formation "{{search}}"
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="trainer-details"
                    *ngFor="let trainer of trainers | filterByNameOrLabel:search:showOnlyActiveTrainers:filterMetadata:'refuse' | filterByAgency:selectedAgency:showOnlyActiveTrainers:filterMetadata:'refuse' | filterByLanguage:selectedLanguage:filterMetadata:'refuse'">
                    <span class="input-group-addon white-icon">
                        <input (ngModelChange)="toggleTrainerSelectedToSendMail(trainer.id)"
                                [(ngModel)]="selectedTrainers[trainer.id].selected"
                                [ngModelOptions]="{standalone: true}" class="checkbox-trainer" type="checkbox"
                                aria-label="checkbox-trainer">
                    </span>
                    <div class="trainer-line"><trainer-card [trainer]="trainer" [inline]="true"></trainer-card></div>
                </div>
            </div>
        </div>
        <br>
        <div class="submit-action-bar">
            <button [disabled]="!isSendMailButtonActive" class="btn btn-zenika" type="submit">
                {{'session-details.sendMail' | translate}}
            </button>
        </div>
    </form>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/staffing/search/staffing-search.component.html